import CustomerDetails from '../../shared/CustomerDetailsPage/CustomerDetails';
import CustomerJourneyStep from '../../shared/CustomerDetailsPage/CustomerJourneyStep';

const CustomerDetailsPage = () => <CustomerDetails JourneySteps={CustomerJourneyStep} />;

export default CustomerDetailsPage;
